import React from 'react';
import ContentArea from '@episerver/spa-core/Components/ContentArea';

function Footer(props) {

const filteredContentArea = {
  ...props.iContent.mainContentArea,
  expandedValue: props.iContent.mainContentArea?.expandedValue?.map(item => {
    if (
      props.isEnergy && // Only filter if isEnergy is true
      item.contentType?.[0] === 'Block' &&
      item.contentType?.[1] === 'NewCoreProductActionsBlock'
    ) {
      return {
        ...item,
        coreProductActions: {
          ...(item.coreProductActions || {}),
          expandedValue: (item.coreProductActions?.expandedValue || []).filter(action => {
            // Only keep actions for Electricity
            return action?.actionServices?.value
              ?.split(',')
              .some(service => service.trim() === 'Electricity');
          }),
        },
      };
    }
    return item;
  })|| [],
};


  return (
    <div className='wrapper-footer-bottom'>
      <div className='background-footer'></div>
      <ContentArea
        noWrap
        key='MainContentArea'
        context={props.context}
        data={filteredContentArea}
        propertyName='MainContentArea'
      />
    </div>
  );
}

export default Footer;
